export const API_URL = "https://staging.api.topcoinuk.com/api"; 
// export const API_URL = "http://localhost:8000/api"; 